import { blue100, grey200, text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  transition_slow,
  transition_slower,
} from 'ext-ui/style/transitionSpeeds'
import { font_family_weight_regular, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: 100%;
  position: relative;

  .sidenav-link {
    display: flex;
    min-height: ${spacing(9)};
    align-items: center;
    align-self: stretch;
    position: relative;
    gap: ${spacing(3)};
    border-radius: ${spacing(2)};
    transition-property: margin, background-color;
    transition-duration: ${transition_slower}, ${transition_slow};
    transition-timing-function: ease-out;

    &.open {
      margin: 0 ${spacing(4)} 0 ${spacing(10)};
    }
    &.closed {
      margin: 0 ${spacing(4)} 0 ${spacing(7.5)};
    }
    &.hover,
    &.active {
      background-color: ${blue100};
    }
    /* TODO: JPM specific style, handle with more generic solution later */
    &.hover.jpm,
    &.active.jpm {
      background-color: ${grey200};
    }
  }

  .sidenav-label {
    position: relative;
    padding: ${spacing(2)} ${spacing(3)};
    width: 100%;
    display: flex;
    gap: ${spacing(1)};
    align-items: center;
    justify-content: space-between;
    ${font_md};
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_regular};
  }

  .sidenav-label-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 1 1 auto;
  }

  .sidenav-pill {
    flex-shrink: 0;
    transition-property: color, background-color;
    transition-duration: ${transition_slow};
    transition-timing-function: ease-out;
  }
`
